import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Redirect, useLocation, useHistory, Link, RouterProps } from 'react-router-dom';
import {
    CButton,
    CHeader,
    CHeaderNav,
    CToggler,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {clearToken} from "../../services/tokenVerify";
import {loggingOff} from "../../store/ducks/login/actions";
import {States} from "../../store/ducks/rootReducer";
import Breadcrumb from './breadCrumb';
import {alternarSidebar} from "../../services/useSidebar";
const TheHeader = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const loginState = useSelector((state:States)=> state.login);
    const [showRollback, setShowRollback] = useState(false);

    useEffect(()=>{
        setShowRollback(location.pathname  !== '/');
    },[location])

    const logout = () => {
        dispatch(loggingOff());
        clearToken();
        return (<Redirect to="/login"/>);
    }

    const rollback = ()=>{
        localStorage.setItem('goBack', 'true');
    }

    return (
        <CHeader>
            {/* So no celular/tablet: no desktop a sidebar fica sempre aberta. */}
            <CToggler inHeader className="ml-2 d-lg-none" onClick={alternarSidebar} aria-label="Abrir o menu"/>
            <CHeaderNav style={{alignItems: 'center', gap: 10, padding: '0 16px'}}>
                {showRollback && (
                    <button onClick={()=>{history.goBack(); rollback()}} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        width: 28, height: 28, borderRadius: 6,
                        background: 'transparent', border: '1.5px solid #e2e8f0',
                        cursor: 'pointer', color: '#718096', flexShrink: 0,
                        transition: 'all 0.15s',
                    }} onMouseEnter={e => {
                        (e.currentTarget as HTMLButtonElement).style.borderColor = '#0085ff';
                        (e.currentTarget as HTMLButtonElement).style.color = '#0085ff';
                    }} onMouseLeave={e => {
                        (e.currentTarget as HTMLButtonElement).style.borderColor = '#e2e8f0';
                        (e.currentTarget as HTMLButtonElement).style.color = '#718096';
                    }}>
                        <CIcon name="cil-arrow-left" style={{width: 13, height: 13}} />
                    </button>
                )}
                <Breadcrumb />
            </CHeaderNav>
            <CHeaderNav className="mr-auto" />
            <CHeaderNav style={{gap: 10, alignItems: 'center', padding: '0 16px'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <div style={{
                        width: 30, height: 30, borderRadius: '50%',
                        background: '#0085ff', color: '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 13, fontWeight: 700, flexShrink: 0,
                        textTransform: 'uppercase',
                    }}>
                        {loginState.data?.user?.name?.charAt(0) ?? '?'}
                    </div>
                    <span className="d-none d-sm-inline" style={{fontSize: 13, color: '#3c4b64', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                        {loginState.data?.user?.name}
                    </span>
                </div>
                <button onClick={logout} style={{
                    display: 'flex', alignItems: 'center', gap: 5,
                    background: 'transparent', border: '1.5px solid #e2e8f0',
                    borderRadius: 8, padding: '4px 10px', cursor: 'pointer',
                    fontSize: 13, color: '#718096', transition: 'all 0.15s',
                }} onMouseEnter={e => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#fc8181';
                    (e.currentTarget as HTMLButtonElement).style.color = '#e53e3e';
                }} onMouseLeave={e => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#e2e8f0';
                    (e.currentTarget as HTMLButtonElement).style.color = '#718096';
                }}>
                    <CIcon name="cil-account-logout" style={{width: 14, height: 14}} />
                    Sair
                </button>
            </CHeaderNav>
        </CHeader>
    )
}

// @ts-ignore
export default TheHeader;